/**
 * Given the chosen parent category, show the possible categories to
 * choose from in the specific category menu.
 */
function updateCategoryMenu() {
	const parentCategoryId = this.currentStepElement.querySelector('select[name="parent_category_id"]').value;
	const categorySelect = this.currentStepElement.querySelector('select[name="category_id"]');
	const currentOptions = this.currentStepElement.querySelectorAll('select[name="category_id"] option[data-parent-category]');

	// Remove existing options if there are any.
	if (currentOptions && currentOptions.length) {
		for (const option of currentOptions) {
			option.remove();
		}
	}

	const applicableOptions = this.currentStepElement.querySelectorAll(`select.quote-request-categories option[data-parent-category="${parentCategoryId}"]`);

	// Then populate the menu with applicable options.
	for (const option of applicableOptions) {
		const optionClone = option.cloneNode(true);
		categorySelect.appendChild(optionClone);
	}

	// Restore selected option?
	if (categorySelect.dataset.categoryId) {
		categorySelect.querySelector(`option[value="${categorySelect.dataset.categoryId}"]`).selected = true;
	}
}

/**
 * When a category is selected we want to keep that fact around. This
 * helps ensure selections won't be lost when going back and forward.
 *
 * We check for this value after populating the menus above in
 * `updateCategoryMenu()`.
 */
function selectCategory() {
	const categoryId = this.currentStepElement.querySelector('select[name="category_id"]').value;
	const categorySelect = this.currentStepElement.querySelector('select[name="category_id"]');
	categorySelect.dataset.categoryId = categoryId;
}

export {
	updateCategoryMenu,
	selectCategory
}